import { jsx as _jsx } from "react/jsx-runtime";
import { useVirtualizer } from "@tanstack/react-virtual";
import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef } from "react";
export const FACE_ROW_HEIGHT = 60;
const _ClipFacesVirtualizedList = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { itemsCount, hasNextPage, fetchNextPage, isFetchingNextPage, children } = param;
    var _virtualItems_;
    const scrollElementRef = useRef(null);
    const virtualizer = useVirtualizer({
        count: hasNextPage ? itemsCount + 1 : itemsCount,
        estimateSize: ()=>FACE_ROW_HEIGHT,
        getScrollElement: ()=>scrollElementRef.current,
        overscan: 10,
        scrollMargin: 8
    });
    useImperativeHandle(forwardedRef, ()=>({
            scrollToRow: (index)=>virtualizer.scrollToIndex(index, {
                    behavior: "smooth"
                })
        }));
    const virtualItems = virtualizer.getVirtualItems();
    useEffect(()=>{
        const lastItem = virtualItems[virtualItems.length - 1];
        if (!lastItem) {
            return;
        }
        if (lastItem.index >= itemsCount - 1 && hasNextPage && !isFetchingNextPage) {
            fetchNextPage();
        }
    }, [
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        virtualItems,
        itemsCount
    ]);
    var _virtualItems__start;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "CLIP_FACES_LIST_SCROLL",
        ref: scrollElementRef,
        className: "w-full flex-1 overflow-y-auto pl-4 pr-2 scrollbar scrollbar-track-grey-2 scrollbar-thumb-grey-7 [&:not(:hover)]:scrollbar-track-transparent",
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative w-full",
            style: {
                height: virtualizer.getTotalSize()
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "absolute left-0 top-0 w-full pb-4",
                style: {
                    transform: "translateY(".concat(((_virtualItems__start = (_virtualItems_ = virtualItems[0]) === null || _virtualItems_ === void 0 ? void 0 : _virtualItems_.start) !== null && _virtualItems__start !== void 0 ? _virtualItems__start : 0) + virtualizer.options.scrollMargin, "px)")
                },
                children: virtualItems.map((virtualRow)=>/*#__PURE__*/ _jsx("div", {
                        "data-index": virtualRow.index,
                        ref: virtualizer.measureElement,
                        children: children({
                            index: virtualRow.index
                        })
                    }, virtualRow.key))
            })
        })
    });
});
_ClipFacesVirtualizedList.displayName = "_ClipFacesVirtualizedList";
export const ClipFacesVirtualizedList = /*#__PURE__*/ memo(_ClipFacesVirtualizedList);
ClipFacesVirtualizedList.displayName = "ClipFacesVirtualizedList";
